import styled from 'styled-components'

export const Flex = styled.div`
  display: flex;
`

export const TrendingContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background: ${props => props.containerBg};
`

export const TrendingCard = styled.div`
  background-color: ${props => props.cardBg};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 50px;
  gap: 30px;

  @media (max-width: 768px){
    padding: 20px;
    gap: 15px;
  }
`

export const TrendingIcon = styled.div`
  background-color: ${props => props.iconBg};
  border-radius: 50%;
  padding: 20px 20px 15px 20px;
  text-align: center;
  color: #ff0000;
  font-size: 35px;

  @media (max-width: 768px){
    font-size: 28px;
    padding: 15px;
  }
`

export const TrendingTitle = styled.h1`
  color: ${props => props.color};
  font-size: 30px;
  font-weight: bold;

  @media (max-width: 768px){
    font-size: 25px;
  }
`

export const TrendingVideos = styled.ul`
  display: grid;
  gap: 30px;
  margin: 40px;

  @media (max-width: 576px){
    margin: 0px;
  }

  @media (max-width: 768px){
    margin: 20px;
  }
`
